import React from "react";
const DevProfile = ({ developerData }) => {
  console.log("developerDatadeveloperData", developerData);
  return (
    <div className="devprofile-content">
      {developerData &&
        developerData?.length > 0 &&
        developerData.map((elem, i) => {
          let date = new Date(elem?.createdAt);
          let monthArray = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          let month = date.getMonth();
          let requiredMonth = monthArray[month];
          let day = date.getDate();
          let year = date.getFullYear();
          return (
            <div className="devprofile-content-box" key={i}>
              <div className="devprofile-detail-top">
                <div className="devprofile-detail">
                  <div className="devprofile-detail-left">
                    <div className="dev-name">
                      <h4>{elem?.userId?.name?elem?.userId?.name:elem?.userId?.firstName}</h4>
                    </div>
                    <div className="dev-address">
                      <p>
                        {elem.city} {elem.country}
                      </p>
                    </div>
                  </div>
                  <div className="devprofile-detail-right">
                    <div className="dev-salary">
                      <p>
                        {"$ "}
                        {elem.salary}
                        <span>/ Month</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="devprofile-detail">
                  <div className="devprofile-detail-left">
                    <div className="dev-tittle">
                      <h5>{elem.job_Title}</h5>
                    </div>
                    <div className="dev-experience">
                      <p>
                        {elem.experience}
                        {"+ years of work experience"}
                      </p>
                      <span>
                        {day}
                        {", "}
                        {requiredMonth} {year}
                      </span>
                    </div>
                  </div>
                  <div className="devprofile-detail-right">
                    <div className="dev-company">
                      {elem.img && <img src={elem.img} alt="logo" />}
                    </div>
                  </div>
                </div>
              </div>
              <div className="dev-bio">
                <p>{elem.profile_Summary}</p>
                {elem.biolist && (
                  <div className="dev-bio-list">
                    <p>{elem.biolist}</p>
                    <ul>
                      {elem.list &&
                        elem.list.length > 0 &&
                        elem.list.map((e) => <li>{e}</li>)}
                    </ul>
                  </div>
                )}
              </div>
              <div className="dev-skill-list">
                {elem.skill.map((e) => (
                  <span>{e}</span>
                ))}
              </div>
            </div>
          );
        })}
      {/* <ListingPagination /> */}
    </div>
  );
};

export default DevProfile;
